import React, { useEffect } from "react";
import CoupensTabCard from "./CoupensTabCard";
import { useDispatch, useSelector } from "react-redux";
import { getCouponByIdAction } from "../../redux/actions";
import Slider from "./Banners2";
import { getEndUserAction } from "../../redux/actions";

const CouponsTab = ({ coupons, match, setShareOfferLink }) => {
  const dispatch = useDispatch();

  const { couponByID, getEndUser } = useSelector((state) => state.Coupon);

  useEffect(() => {
    if (match.params.couponId !== undefined && couponByID?._id === undefined) {
      dispatch(getCouponByIdAction({ coupon_id: match.params.couponId }));
    }
    if (match.params.couponId !== undefined && couponByID?._id !== undefined) {
      window.open(
        `/couponsredirect/store/${match.params.storeSlug}/coupon/${match.params.storeName}/${match.params.couponId}`,
        "_blank"
      );
    }
  }, [match, couponByID, dispatch]);

  React.useEffect(() => {
    dispatch(getEndUserAction());
  }, [dispatch]);

  return (
    <div role="tabpanel" className="tab-pane fade active in" id="reviews">
      <section className="tab-content">
        <div className="row">
          {coupons?.map((coupon, i) => (
            <>
              <CoupensTabCard
                setShareOfferLink={setShareOfferLink}
                coupon={coupon}
              ></CoupensTabCard>

              {i == 1 && (
                <>
                  <Slider getEndUser={getEndUser} />
                </>
              )}
            </>
          ))}
        </div>
      </section>
    </div>
  );
};

export default CouponsTab;
